import React, { FC, useEffect, useState } from "react";

import { Header, Column, Table } from "@tanstack/react-table";
import { DebouncedInput } from "../dnd/DebouncedInput";

import classes from "./Filter.module.scss";
import { colorSelect } from "../../../commons/columnColor";
import { useRecoilValue } from "recoil";
import { userState } from "../../../states/userState";
import {
  backColorTableRowAdd,
  backColorTableRowEven,
  backgroundColor,
} from "../../../commons/colors";
type Post = {
  userId: number;
  id: number;
  title: string;
  body: string;
  url: Array<Url>;
};
type Url = {
  name: string;
  url: string;
};
export const Filter = ({
  column,
  header,
  table,
}: {
  column: Column<any, unknown>;
  header: Header<Post, unknown>;
  table: Table<any>;
}) => {
  const user = useRecoilValue(userState);
  const firstValue = table
    .getPreFilteredRowModel()
    .flatRows[0]?.getValue(column.id);

  const columnFilterValue = column.getFilterValue();

  const sortedUniqueValues = React.useMemo(
    () =>
      typeof firstValue === "number"
        ? []
        : Array.from(column.getFacetedUniqueValues().keys()).sort(),
    [column.getFacetedUniqueValues()]
  );
  const colorStyle = colorSelect(header.column.columnDef.id ?? "");

  return typeof firstValue === "number" ? (
    <div className={classes.container}>
      <DebouncedInput
        type="number"
        min={Number(column.getFacetedMinMaxValues()?.[0] ?? "")}
        max={Number(column.getFacetedMinMaxValues()?.[1] ?? "")}
        value={(columnFilterValue as [number, number])?.[0] ?? ""}
        onChange={(value) =>
          column.setFilterValue((old: [number, number]) => [value, old?.[1]])
        }
        placeholder={`Min ${
          column.getFacetedMinMaxValues()?.[0]
            ? `(${column.getFacetedMinMaxValues()?.[0]})`
            : ""
        }`}
        className={
          user?.mode !== "lite"
            ? colorStyle === "base"
              ? classes.inputNumber
              : colorStyle === "processPt"
              ? classes.inputNumberProcessPt
              : colorStyle === "processPv"
              ? classes.inputNumberProcessPv
              : classes.inputNumberSite
            : colorStyle === "base"
            ? classes.inputNumberDark
            : colorStyle === "processPt"
            ? classes.inputNumberProcessPtDark
            : colorStyle === "processPv"
            ? classes.inputNumberProcessPvDark
            : classes.inputNumberSiteDark
        }
        style={backColorTableRowEven(user?.mode ?? "lite")}
      />
      <DebouncedInput
        type="number"
        min={Number(column.getFacetedMinMaxValues()?.[0] ?? "")}
        max={Number(column.getFacetedMinMaxValues()?.[1] ?? "")}
        value={(columnFilterValue as [number, number])?.[1] ?? ""}
        onChange={(value) =>
          column.setFilterValue((old: [number, number]) => [old?.[0], value])
        }
        placeholder={`Max ${
          column.getFacetedMinMaxValues()?.[1]
            ? `(${column.getFacetedMinMaxValues()?.[1]})`
            : ""
        }`}
        className={
          user?.mode !== "lite"
            ? colorStyle === "base"
              ? classes.inputNumber
              : colorStyle === "processPt"
              ? classes.inputNumberProcessPt
              : colorStyle === "processPv"
              ? classes.inputNumberProcessPv
              : classes.inputNumberSite
            : colorStyle === "base"
            ? classes.inputNumberDark
            : colorStyle === "processPt"
            ? classes.inputNumberProcessPtDark
            : colorStyle === "processPv"
            ? classes.inputNumberProcessPvDark
            : classes.inputNumberSiteDark
        }
        style={backColorTableRowEven(user?.mode ?? "lite")}
      />
    </div>
  ) : (
    <div className={classes.container}>
      <datalist id={column.id + "list"}>
        {sortedUniqueValues.slice(0, 5000).map((value: any) => (
          <option value={value} key={value} />
        ))}
      </datalist>
      <DebouncedInput
        type="text"
        value={(columnFilterValue ?? "") as string}
        onChange={(value) => column.setFilterValue(value)}
        // placeholder={`Search... (${column.getFacetedUniqueValues().size})`}
        placeholder={`Search... `}
        className={
          user?.mode !== "lite"
            ? colorStyle === "base"
              ? classes.input
              : colorStyle === "processPt"
              ? classes.inputProcessPt
              : colorStyle === "processPv"
              ? classes.inputNumberProcessPv
              : classes.inputSite
            : colorStyle === "base"
            ? classes.inputDark
            : colorStyle === "processPt"
            ? classes.inputProcessPtDark
            : colorStyle === "processPv"
            ? classes.inputNumberProcessPvDark
            : classes.inputSiteDark
        }
        list={column.id + "list"}
        style={backColorTableRowEven(user?.mode ?? "lite")}
      />
    </div>
  );
};
